import React from 'react'

export const LocationPointSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="43"
      viewBox="0 0 28 43"
      fill="none"
    >
      <path
        d="M14 0C6.26 0 0 6.58625 0 14.7296C0 25.7769 14 42.0847 14 42.0847C14 42.0847 28 25.7769 28 14.7296C28 6.58625 21.74 0 14 0Z"
        fill="#222222"
      />
      <path
        d="M21.0646 19.9892H7V13.234L14.0691 7.36377L21.0646 13.237V19.9892ZM8.71783 18.204H19.3467V14.0906L14.0633 9.65455L8.71783 14.0936V18.204Z"
        fill="white"
      />
      <path
        d="M14.0763 15.2051C14.8672 15.2051 15.5083 14.5389 15.5083 13.717C15.5083 12.8951 14.8672 12.2288 14.0763 12.2288C13.2854 12.2288 12.6443 12.8951 12.6443 13.717C12.6443 14.5389 13.2854 15.2051 14.0763 15.2051Z"
        fill="white"
      />
    </svg>
  )
}
